
import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactHero from "@/components/contact/ContactHero";
import ContactInfo from "@/components/contact/ContactInfo";
import ContactForm from "@/components/contact/ContactForm";
import { Separator } from "@/components/ui/separator";

const Contact: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50">
      <Navbar />
      <main className="flex-grow">
        {/* Hero Section */}
        <ContactHero backgroundImage="/lovable-uploads/835b8b6d-f894-4bff-85a0-088b2d0be56f.png" />

        {/* Contact Content */}
        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            {/* Section Header */}
            <div className="text-center mb-16">
              <h2 className="text-3xl md:text-4xl font-heading font-bold text-fabre-gray mb-4">
                Comment pouvons-nous vous aider ?
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Notre équipe d'experts est à votre disposition pour répondre à toutes vos questions 
                et vous accompagner dans vos projets environnementaux.
              </p>
              <Separator className="w-24 mx-auto mt-8 bg-fabre-green h-1" />
            </div>
            
            <div className="flex flex-col lg:flex-row gap-12 max-w-7xl mx-auto">
              <div className="lg:w-1/3">
                <ContactInfo />
              </div>
              
              <div className="lg:w-2/3">
                <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12 border border-gray-100">
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Trust indicators */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="text-center">
                <div className="w-16 h-16 bg-fabre-lightgreen rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-fabre-green">✓</span>
                </div>
                <h3 className="font-heading font-semibold mb-2">Réponse Rapide</h3>
                <p className="text-gray-600 text-sm">Nous vous répondons dans les 24h ouvrées</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-fabre-lightgreen rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-fabre-green">👥</span>
                </div>
                <h3 className="font-heading font-semibold mb-2">Équipe Experte</h3>
                <p className="text-gray-600 text-sm">Des professionnels qualifiés à votre service</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-fabre-lightgreen rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-2xl font-bold text-fabre-green">🏆</span>
                </div>
                <h3 className="font-heading font-semibold mb-2">Solutions Sur Mesure</h3>
                <p className="text-gray-600 text-sm">Des réponses adaptées à vos besoins spécifiques</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
